import React from 'react';

export type InputLabelProps = {
    name: string;
    labelText: string;
    className?: string;
};

const InputLabel = ({ name, labelText, className = '' }: InputLabelProps) => {
    return labelText === '' ? (
        <></>
    ) : (
        <label className={className} aria-label={labelText} htmlFor={name}>
            {labelText}
        </label>
    );
};

export default InputLabel;
